<template>
    <app-layout v-if="isPageReady" :showTrialPeriodBar="false">
        <common-page-plain>
            <common-content-spacer height="medium">
                <common-page-header
                    :heading="$t('pages.public.find_provider.heading')"
                    :content="$t('pages.public.find_provider.description')"
                    :isCenter="true"
                ></common-page-header>

                <common-content-wrapper width="small">
                    <referrals-new-search-form
                        :insurancePlans="insurancePlans"
                        :specialities="specialities"
                        :states="states"
                        :facilityServices="facilityServices"
                        @sent="showResults($event)"
                    ></referrals-new-search-form>
                </common-content-wrapper>
            </common-content-spacer>
        </common-page-plain>
    </app-layout>
</template>

<script>
    import ReferralsNewSearchForm from 'components/forms/ReferralsNewSearchForm'
    import InsurancePlanGroupsAPI from 'api/InsurancePlanGroupsAPI'
    import SpecialitiesAPI from 'api/SpecialitiesAPI'
    import StatesAPI from 'api/StatesAPI'
    import AppLayout from 'components/layouts/AppLayout'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'

    export default {
        metaInfo() {
            if (process.env.VUE_APP_ENV === 'production') {
                return {
                    title: this.$t('pages.auth.find_provider.title'),
                    meta: [
                        { name: 'description', content: this.$t('pages.auth.find_provider.page_description') },
                        { name: 'keywords', content: this.$t('pages.auth.find_provider.page_keywords') },
                        { name: 'author', content: this.$t('pages.auth.find_provider.page_author') },
                        { name: 'robots', content: this.$t('pages.auth.find_provider.page_robots') },
                    ],
                }
            }
        },

        mixins: [PageWithDataMixin],
        components: {
            AppLayout,
            ReferralsNewSearchForm,
        },

        data() {
            return {
                insurancePlans: [],
                specialities: [],
                states: [],
                facilityServices: [],
            }
        },

        loadData() {
            return {
                insurancePlans: InsurancePlanGroupsAPI.getList(),
                specialities: SpecialitiesAPI.getList(),
                states: StatesAPI.getList(),
            }
        },

        methods: {
            showResults(query) {
                localStorage.setItem('findProviderQuery', JSON.stringify(query))
                this.$router.push({
                    name: 'public.find-provider.results',
                    query: query,
                    params: {
                        existingReferral: this.$route.params.existingReferral,
                    },
                })
            },
        },
    }
</script>
